// graphql query to fetch all products
const fetchManuals = async (after, storefrontUrl, accessToken) => {
  let afterQuery = '';
  if (after) {
    afterQuery = `, after: "${after}"`;
  }
  const query = `
    {
      metaobjects(type: "assembly_files", first: 250${afterQuery}) {
        edges {
          node {
            id
            fields {
              key
              value
              references(first: 200) {
                edges {
                  node {
                    ... on GenericFile {
                      id
                      url
                    }
                    ... on MediaImage {
                      id
                      image {
                        url
                      }
                    }
                    ... on Video {
                      id
                      sources {
                        url
                      }
                    }
                  }
                }
              }
            }
          }
        }
        pageInfo {
          endCursor
          startCursor
          hasNextPage
        }
      }
    }
  `;

  const response = await fetch(storefrontUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': accessToken,
    },
    body: JSON.stringify({ query }),
  });

  const data = await response.json();
  const files = data.data.metaobjects;
  return files;
};

const fetchAllManuals = async (storefrontUrl, accessToken) => {
  let hasNextPage = false;
  let after = null;
  const allManuals = [];

  do {
    let results = await fetchManuals(after, storefrontUrl, accessToken);
    hasNextPage = results.pageInfo.hasNextPage;
    after = results.pageInfo.endCursor;
    allManuals.push(...results.edges);
  } while (hasNextPage);

  return allManuals;
};

const performSearch = async (
  allManuals,
  searchInput,
  storefrontUrl,
  accessToken
) => {
  const searchValue = searchInput;

  if (!searchValue) {
    return;
  }

  const results = allManuals.filter((manual) => {
    const manualFields = manual.node.fields;
    return manualFields.some((field) =>
      field.value.toUpperCase().includes(searchValue.toUpperCase())
    );
  });

  if (results.length === 0) {
    const noResults = document.createElement('div');
    noResults.innerHTML =
      '<p class="text-center mt-4 md:col-span-5 w-full">no-results</p>';
    return noResults;
  } else {
    return renderResults(results);
  }
};

const renderResults = (results) => {
  const searchResults = document.createElement('div');
  searchResults.innerHTML = '';
  searchResults.classList.add(
    'w-full',
    'grid',
    'grid-cols-1',
    'md:grid-cols-2',
    'items-start',
    'justify-start',
    'gap-4'
  );
  searchResults.dataset.countResults = results.length;

  results.forEach((result) => {
    const manualItem = document.createElement('ul');
    manualItem.classList.add('pb-2');
    const liElem = document.createElement('li');
    const titleElem = document.createElement('p');
    // get title
    const title = result.node.fields.find((field) => field.key === 'title');
    titleElem.textContent = title.value;
    titleElem.classList.add('!font-bold', '!text-lg');
    liElem.appendChild(titleElem);

    // get files
    const manualFiles = result.node.fields.find(
      (field) => field.key === 'files'
    );
    const files = manualFiles.references.edges;
    const filesUl = document.createElement('ul');
    filesUl.classList.add('list-none', '!py-2', '!gap-2');
    files.forEach((file, index) => {
      const fileLi = document.createElement('li');

      // generic files
      const fileElem = document.createElement('a');
      fileElem.classList.add('!underline', '!mb-4', '!ml-5');
      fileElem.target = '_blank';

      if (file.node.id.includes('GenericFile')) {
        fileElem.href = file.node.url;
        fileElem.textContent = 'Download - File ' + (index + 1);
        fileLi.appendChild(fileElem);
      }
      // videos
      if (file.node.id.includes('Video')) {
        fileElem.href = file.node.sources[0].url;
        fileElem.textContent = 'Watch - Video ' + (index + 1);
        fileLi.appendChild(fileElem);
      }

      // images
      if (file.node.id.includes('MediaImage')) {
        fileElem.href = file.node.image.url;
        fileElem.textContent = 'View - Image ' + (index + 1);
        fileLi.appendChild(fileElem);
      }

      filesUl.appendChild(fileLi);
    });

    liElem.appendChild(filesUl);

    manualItem.appendChild(liElem);
    searchResults.appendChild(manualItem);
  });

  const searchResultsContainer = document.createElement('div');
  searchResultsContainer.appendChild(searchResults);
  return searchResultsContainer;
};

const searchPages = async (query) => {
  const resultsContainer = document.createElement('div');
  const noResultsText = document.querySelector('[data-no-results-text]');
  const response = await fetch(
    `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=page`
  );

  const data = await response.json();

  if (data) {
    const results = data.resources.results.pages;
    if (results.length > 0) {
      resultsContainer.innerHTML = '';
      const ulElem = document.createElement('ul');
      results.forEach((item, index) => {
        const liElem = document.createElement('li');
        const aElem = document.createElement('a');
        aElem.href = item.url;
        aElem.textContent = item.title;
        liElem.appendChild(aElem);
        ulElem.appendChild(liElem);
      });

      resultsContainer.appendChild(ulElem);
    } else {
      resultsContainer.innerHTML = `<p class="text-center mt-4 md:col-span-5">${noResultsText}</p>`;
    }
  }
  return resultsContainer.innerHTML;
};

export { fetchAllManuals, performSearch, searchPages };
